import Swal from 'sweetalert2';

export const ESTIMATE_PDF_TYPES = {
    qty: 'Concrete Qty Estimate',
    rate: 'Concrete Rate Estimate',
    both: 'Both',
};

export function estimatePdfTitle(pdfType) {
    if (pdfType === 'rate') {
        return 'Concrete Rate Estimate PDF';
    }
    if (pdfType === 'both') {
        return 'Concrete Qty & Rate Estimate PDF';
    }
    return 'Concrete Qty Estimate PDF';
}

export function chooseEstimatePdfType(defaultType = 'qty') {
    return Swal.fire({
        title: 'Client requirement',
        text: 'Generate Concrete Qty Estimate, Concrete Rate Estimate, or Both.',
        input: 'radio',
        inputOptions: ESTIMATE_PDF_TYPES,
        inputValue: defaultType || 'qty',
        showCancelButton: true,
        confirmButtonText: 'Generate PDF',
        cancelButtonText: 'Cancel',
        inputValidator: (value) => (value ? undefined : 'Select an option'),
    }).then((result) => (result.isConfirmed ? result.value : null));
}
